import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const TimePicker = ({ value, handleTimeSelect, setIsTime }) => {
    const { t } = useTranslation();
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['StaticDatePicker']}>
                    <DemoItem>
                        <DemoItem label="Static variant">
                            <StaticTimePicker defaultValue={dayjs(value)} onChange={handleTimeSelect}
                                slotProps={{
                                    actionBar: {
                                        actions: []
                                    }
                                }}
                                sx={{
                                    '& .MuiPickersDay-root.Mui-selected': {
                                        backgroundColor: '#FA6400 !important',
                                    },
                                    '& .MuiPickersDay-root.MuiPickersDay-today': {
                                        border: '2px solid #FA6400',
                                    },
                                }} />
                        </DemoItem>
                        <div className="date_button">
                            <button onClick={() => setIsTime(false)} className='px-[8px] py-[6px] text-blue-500 w-[70px]'>{t("CANCEL")}</button>
                            <button onClick={() => setIsTime(false)} className='px-[8px] py-[6px] text-blue-500 w-[70px]'>{t("OK")}</button>
                        </div>
                    </DemoItem>
                </DemoContainer>
            </LocalizationProvider>
        </div>
    )
}

export default TimePicker